export default __webpack_public_path__ + "static/media/bathroom2-afterA-768w.6304527a.webp";